import { render } from "./HeaderOverlayMobile.vue?vue&type=template&id=63adde4d&scoped=true"
import script from "./HeaderOverlayMobile.vue?vue&type=script&lang=js"
export * from "./HeaderOverlayMobile.vue?vue&type=script&lang=js"

import "./HeaderOverlayMobile.vue?vue&type=style&index=0&id=63adde4d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63adde4d"]])

export default __exports__